import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "bottomBar",
  class: "gfu-layout-bar gfu-layout-bar--bottom"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_back_project_button = _resolveComponent("back-project-button")
  const _component_follow_project_button = _resolveComponent("follow-project-button")
  const _component_bottom_bar = _resolveComponent("bottom-bar")
  const _component_mini_wizard_expandable = _resolveComponent("mini-wizard-expandable")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.isBottomActionVisible)
      ? (_openBlock(), _createBlock(_component_bottom_bar, {
          key: 0,
          "with-transition": $data.withTransition,
          onAfterEnter: $options.afterEnter
        }, {
          default: _withCtx(() => [
            ($options.isBackProjectVisible)
              ? (_openBlock(), _createBlock(_component_back_project_button, {
                  key: 0,
                  theme: $options.backProjectButtonTheme
                }, null, 8 /* PROPS */, ["theme"]))
              : ($options.isFollowVisible)
                ? (_openBlock(), _createBlock(_component_follow_project_button, {
                    key: 1,
                    "project-id": $options.projectId,
                    "project-name": $options.projectName,
                    "show-overlay": false,
                    class: "gfu-1of1",
                    section: "bottom-bar"
                  }, null, 8 /* PROPS */, ["project-id", "project-name"]))
                : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["with-transition", "onAfterEnter"]))
      : ($options.canShowMiniWizard)
        ? (_openBlock(), _createBlock(_component_mini_wizard_expandable, _normalizeProps(_mergeProps({ key: 1 }, _ctx.$props)), null, 16 /* FULL_PROPS */))
        : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}